import { render } from "./SectionTitle.vue?vue&type=template&id=170b1858"
const script = {}
script.render = render

export default script